import { find, map } from 'lodash'
import { CustomerData } from '../apis/customer.api'

export default {
  searchOptions (customers: CustomerData[]) {
    return map(customers, customer => {
      const { id, name } = customer
      return { id, value: name }
    })
  },

  find (customers: CustomerData[], id: number) {
    return find(customers, { id })
  }
}
